import Vue from 'vue';
import Router from 'vue-router';
import enterpriseIntroduce from '@/components/enterpriseIntroduce'; //企业介绍
import caseView from '@/components/caseView'; //案例展示
import teamOfExperts from '@/components/teamOfExperts'; //专家团队
import mentalKnowledge from '@/components/mentalKnowledge'; //心理知识
import connectUs from '@/components/connectUs'; //联系我们
import vbody from '@/components/vbody';
import Home from '@/components/home';
export default new Router({
  mode: 'history',
  base: '/',
  routes: [{
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/vbody',
      name: 'vbody',
      component: vbody
    },
    {
      path: '/enterpriseIntroduce',
      name: 'enterpriseIntroduce',
      component: enterpriseIntroduce
    },
	{
	  path: '/caseView',
	  name: 'caseView',
	  component: caseView
	},
    {
      path: '/teamOfExperts',
      name: 'teamOfExperts',
      component: teamOfExperts
    },
    {
      path: '/mentalKnowledge',
      name: 'mentalKnowledge',
      component: mentalKnowledge
    },
    {
      path: '/connectUs',
      name: 'connectUs',
      component: connectUs
    }

  ]
})
Vue.use(Router);



// WEBPACK FOOTER //
// ./src/router/index.js